import { Typography, Box, Badge, IconButton, AppBar, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { HeaderStyles } from "../../styles/layout";
import { Bell, User } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { EventSourcePolyfill } from 'event-source-polyfill';
import { ApiConfig } from '@shared/Config/config';

const Header = () => {
  const theme = useTheme();
  const classes = HeaderStyles(theme);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [count, setCount] = useState(0);
  const token = sessionStorage.getItem('token');

  const setEmailer = () => {
    let email = sessionStorage.getItem("email");
    setEmail(email || "");
  }

  useEffect(() => {
    if (!token) return;
    const source = new EventSourcePolyfill(
      `${ApiConfig.baseUrl}/super_admin/notificationCountStream`,
      {
        headers: {
          Authorization: `${token}`,
        },
        withCredentials: true, // include cookies if needed
      }
    );
    source.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setCount(data?.data?.count);
    };
    source.onerror = (err) => {
      console.error('EventSource Error:', err);
    };
    return () => source.close();
  }, [token]);

  useEffect(() => {
    setEmailer();
  }, []);

  return (
    <AppBar position="static" color={theme.palette.background.paper} elevation={0}>
      <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>

        <Box sx={classes.flex_c}>

          <IconButton color="inherit"
            onClick={() => { navigate("/home/notifications") }}>
            <Badge color="error" badgeContent={count}>
              <Bell size={20} />
            </Badge>
          </IconButton>

          {/* Profile */}
          <Box sx={classes.flex_c}>
            <Box sx={classes.userIcon}>
              <User size={18} />
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="500">
                Super Admin
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {email || ""}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
